import { NotificationsItemList } from '../types';
import fetchApi from '../../../lib/fetchApi';

const BASE_URL: string = "/notification";

export const deleteNotification = async (id:number): Promise<void> => {
    try{
        await fetchApi.put(`${BASE_URL}/delete/${id}`);
            } catch (error) {
        throw error;
    }
};

export const markNotificationAsRead = async (id: number): Promise<void> => {
    try{
        await fetchApi.put(`${BASE_URL}/read/${id}`);
    } catch (error) {
        throw error;
    }
};

export const markAllNotificationsAsRead = async (onlyPersonal: boolean): Promise<void> => {
    await fetchApi.put(`${BASE_URL}/read-all/${onlyPersonal}`);
};

export const getNotifications = async (onlyPersonals: boolean): Promise<NotificationsItemList[]> => {
    try{
        const response = await fetchApi.get(`${BASE_URL}?onlyPersonals=${onlyPersonals}`) as NotificationsItemList[];
        return response;
    } catch (error) {
        throw error;
    }
};
